module.exports = __webpack_public_path__ + "static/media/PackageHoldLogoWhite.144c1763.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/PackageHoldLogoWhite.png
// module id = 180
// module chunks = 0